import { Injectable } from '@angular/core';
import {
  IRealtimeClient,
  ServerRTEConfig,
  WebRTEConfig,
} from '@gains-com/realtime';

@Injectable({
  providedIn: 'root',
})
export class RealtimeMock
  implements IRealtimeClient<WebRTEConfig, ServerRTEConfig>
{
  ready = true;

  initialize = () => Promise.resolve();

  refreshAuthKey = () => Promise.resolve();

  reconnect = () => {};

  disconnect = () => {};

  token = {} as any;

  pubnub = {
    setUserId: () => {},
  } as any;

  createSubscription: any = () => {};

  publishMessage: any = () => {};
}
